import { render, staticRenderFns } from "./RegularizationEditForm.vue?vue&type=template&id=0283f185&"
import script from "./RegularizationEditForm.vue?vue&type=script&lang=js&"
export * from "./RegularizationEditForm.vue?vue&type=script&lang=js&"
import style0 from "./RegularizationEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports